import { useState } from 'react';
import { createNote } from '../services/api';

const NoteCreate = ({ authToken, contentType, patientId, onNoteCreated }) => {
  const [content, setContent] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!content.trim()) {
      setError('Note content cannot be empty');
      return;
    }
    setIsLoading(true);
    setError(null);
    try {
      await createNote(authToken, contentType, patientId, { content });
      setContent('');
      if (onNoteCreated) onNoteCreated();
    } catch (error) {
      console.error('Error creating note:', error);
      setError('Failed to create note. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="mt-2 mb-2">
      <h3 className="text-lg font-bold">Create New Note</h3>
      {error && (
        <div className="text-red-500 mb-2">{error}</div>
      )}
      <form onSubmit={handleSubmit}>
        <textarea
          className="w-full p-2 border rounded"
          rows="4"
          value={content}
          onChange={(e) => setContent(e.target.value)}
          placeholder="Enter your note here..."
        ></textarea>
        <div className="flex justify-end mt-2">
          <button
            data-attr="lead-add-note"
            type="submit"
            className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-teal-700 hover:bg-teal-800 focus:ring-2 focus:ring-teal-500 disabled:opacity-50 disabled:cursor-not-allowed"
            disabled={isLoading}
          >
            {isLoading ? 'Creating...' : 'Save Note'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default NoteCreate;